import { ICandyComponentHandle } from "./ICandyComponentHandle";
import { IControlRegistry } from "./IControlRegistry";

export class NullControlRegistry implements IControlRegistry {
    public registerComponentHandle(): void {
        // noop
    }

    public unregisterComponentHandle(): void {
        // noopBase
    }

    public getBindingPaths(): Iterable<string> {
        return [];
    }

    public getComponentHandles(): readonly ICandyComponentHandle[] | undefined {
        return undefined;
    }
}
